
import './Body.css';
import backgroundImage from '../assets/images/backgroundImage.png';
import React from "react";

function Body(props) {
    return (
        <div className="body">
            <img className="bodyBackgroundImage" src={backgroundImage} alt="illustration of three shadow figures walking, with black oval outlines swirling around the figures" />
            <div className="row">
                <div className="bodyRectangle bodyRectangle1">
                    <div className="innerBodyRectangle">
                            <h2 className="innerBodyHeader"> Minimally Processed </h2>
                             <p className="innerBodyBody"> What does it mean? </p>
                            <a href="/story/welcomeTo">
                                <p className="buttonText"> LEARN MORE</p>
                            </a>
                    </div>
                    <div className="innerBodyRectangle">
                        <h2 className="innerBodyHeader"> ADDICTED TO SUGAR? </h2>
                        <p className="innerBodyBody"> I used to be. Let us help you break up with added sugar. </p>
                        <a href="https://www.quit-sugar.com/">
                            <p className="buttonText"> LEARN MORE</p>
                        </a>
                    </div>
                </div>
                <div className="bodyRectangle bodyRectangle2"></div>
                <div className="bodyRectangle bodyRectangle3">
                    <div className="innerBodyRectangle smallRectangleInnerBody">
                        <h2 className="innerBodyHeader"> STORIES: </h2>
                    </div>
                    <div className="innerBodyRectangle smallRectangleInnerBody">
                        <a href="/story/phaseStructure">
                            <p className="innerBodyBody"> phase based program </p>
                        </a>
                    </div>
                    <div className="innerBodyRectangle smallRectangleInnerBody">
                        <a href="/story/phaseOne">
                            <p className="innerBodyBody"> phase 1 of minimally processed </p>
                        </a>
                    </div>
                    <div className="innerBodyRectangle smallRectangleInnerBody">
                        <a href="/story/textureSensitivity">
                            <p className="innerBodyBody"> what are texture sensitivities? </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Body;